// ユーザー認証のエンティティ
export class UserAuth {
  // ユーザーID DB型(*id)
  public user_id?: string;
  // ユーザー名(ニックネーム) DB型(varchar(256))
  public user_name?: string;
  // パスワードハッシュ DB型(varchar(256))
  public password_hash?: string;
  // メールアドレス DB型(varchar(256))
  public email?: string;
  // LINEユーザーID DB型(varchar(256))
  public line_user_id?: string;
  // LINEログイントークン DB型(varchar(256))
  public line_login_token?: string;
  // ユーザ種別 DB型(varchar(10))
  public user_type?: string;
  // ログイン回数 DB型(int(10))
  public login_count?: number;
  // 最終ログイン日時 DB型(timestamp)
  public last_login_dt?: Date;
  // プロフィール入力済み DB型(*flg)
  public is_complete?: boolean;
  // ライン公式登録済み DB型(*flg)
  public is_join_line_at?: boolean;
  // 未読件数 DB型(INT)
  public not_reading_count?: number;
  static fromDB(record: { [column: string]: any; [column: number]: any }): UserAuth {
    const entity = new UserAuth();
    entity.user_id = record['user_id'];
    entity.user_name = record['user_name'];
    entity.password_hash = record['password_hash'];
    entity.email = record['email'];
    entity.line_user_id = record['line_user_id'];
    entity.line_login_token = record['line_login_token'];
    entity.user_type = record['user_type'];
    entity.login_count = record['login_count'];
    entity.last_login_dt = record['last_login_dt'];
    entity.is_complete = record['is_complete'];
    entity.is_join_line_at = record['is_join_line_at'];
    entity.not_reading_count = record['not_reading_count'];
    return entity;
  }
  static getTypeFitEntity(value: any): UserAuth {
    const entity = new UserAuth();
    entity.user_id = value.user_id;
    entity.user_name = value.user_name;
    entity.password_hash = value.password_hash;
    entity.email = value.email;
    entity.line_user_id = value.line_user_id;
    entity.line_login_token = value.line_login_token;
    entity.user_type = value.user_type;
    entity.login_count = value.login_count;
    entity.last_login_dt = value.last_login_dt;
    entity.is_complete = value.is_complete;
    entity.is_join_line_at = value.is_join_line_at;
    entity.not_reading_count = value.not_reading_count;
    return entity;
  }
}
